<template>
<div class="chapter">
<div class="inner_page">
<p class="p3">To my mother, who inspires me.</p>
<p> </p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?b9fade22